const TAG = /^[A-Za-z0-9][A-Za-z0-9-]{1,31}$/

/** What a label says: a URL ending in /a/<TAG> (the printed QR), or the tag itself (typed, or read from a damaged label). */
export function tagFromScan(text: string): string | null {
  const s = text.trim()
  if (!s) return null
  try {
    const u = new URL(s)
    const m = /\/a\/([^/?#]+)\/?$/.exec(u.pathname)
    if (m) { const t = decodeURIComponent(m[1]!); return TAG.test(t) ? t.toUpperCase() : null }
    return null
  } catch { /* not a URL */ }
  const bare = s.replace(/\s+/g, '-')
  return TAG.test(bare) ? bare.toUpperCase() : null
}
